import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon, SmartphoneIcon, StarIcon } from 'lucide-react';
import { bonuses } from '../data/volumes';
export function Bonuses() {
  return <section aria-label="Bonuses" className="border-y border-gold/30 bg-white/70" data-id="element-16" data-mp="avlbuhg5sxm9">
      <div className="mx-auto max-w-5xl px-5 py-12" style={{
      paddingTop: "14px",
      paddingBottom: "22px"
    }} data-id="element-17" data-mp="fu6c2gvevhap">
        <h2 className="text-center font-display text-2xl font-black text-plum sm:text-4xl" data-id="element-18" data-mp="1un35lus01xc">
          🎁 4 Professional Bonuses Included
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-center text-sm font-bold uppercase tracking-wide text-blush" data-id="element-19" data-mp="5xjsdvetmwa9">
          Only with the complete system
        </p>

        <div className="mt-10 grid gap-5 sm:grid-cols-2" data-id="element-20" data-mp="3szwo2z3wxq03">
          {bonuses.map((b, i) => <motion.div key={b.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.3,
          delay: i % 2 * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="relative flex gap-4 rounded-2xl border border-gold/40 bg-cream p-5" data-id="element-21" data-mp="1mai3lz3qa0xb" data-mpi={i}>
              <img src={b.cover} alt={`${b.title} bonus cover`} width={1122} height={1402} loading="lazy" decoding="async" sizes="112px" className="h-auto w-24 shrink-0 self-start object-contain drop-shadow-[0_10px_18px_rgba(28,36,24,0.35)] sm:w-28" data-id="element-22" data-mp="3dd8xey508vr0" />
              <div className="flex min-w-0 flex-1 flex-col" data-id="element-23" data-mp="2zglqq3n92r7w">
                <div className="mb-3 flex flex-wrap items-center justify-between gap-2" data-id="element-24" data-mp="2ugha8dmcdwho">
                  <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-lilac-soft px-3 py-1 text-xs font-bold text-grape-deep" data-id="element-25" data-mp="2uiu1jhdzpj7e">
                    <GiftIcon className="h-3.5 w-3.5" data-id="element-26" data-mp="33ge5iy38ltlp" /> Bonus {b.n}
                  </span>
                  <span className="whitespace-nowrap text-sm font-bold" data-id="element-27" data-mp="nozvuihvvu4w">
                    <span className="text-plum/40 line-through" data-id="element-28" data-mp="irgbd0ulel4i">{b.price}</span>{' '}
                    <span className="text-grape" data-id="element-29" data-mp="3cj6j4itme0rh">FREE</span>
                  </span>
                </div>
                <h3 className="text-base font-black text-plum" data-id="element-30" data-mp="3hhr8tob8x21o">{b.title}</h3>
                <p className="mt-1 text-sm font-semibold text-blush" data-id="element-31" data-mp="3hju9r3dxsfl6">{b.tagline}</p>
                <p className="mt-2 text-sm leading-relaxed text-plum/65" data-id="element-32" data-mp="3lke7a82f9l7u">{b.desc}</p>
                <p className="mt-auto flex items-center gap-1.5 pt-3 text-xs font-semibold text-plum/55" data-id="element-33" data-mp="3qi5wgubomt8c">
                  Perceived value:
                  <span className="flex gap-0.5 text-gold" aria-label="5 out of 5 stars" data-id="element-34" data-mp="2xu0cwawd7aa3">
                    {Array.from({
                  length: 5
                }).map((_, k) => <StarIcon key={k} className="h-3.5 w-3.5 fill-current" data-id="element-35" data-mp="32s24xlbrqjxp" data-mpi={k} />)}
                  </span>
                </p>
              </div>
            </motion.div>)}
        </div>

        <p className="mt-8 flex items-center justify-center gap-2 text-center text-sm font-semibold text-plum/60" data-id="element-36" data-mp="2a4z950yh8nb5">
          <SmartphoneIcon className="h-4 w-4 shrink-0 text-grape" aria-hidden="true" data-id="element-37" data-mp="2f2r2lzershhg" />
          Access everything from your desktop, tablet or phone — your entire author system fits directly into your writing workflow.
        </p>

        <div className="mt-6 rounded-2xl border border-gold/50 bg-blush-soft p-4 text-center" data-id="element-38" data-mp="22lpyl4e8iiki">
          <p className="text-base font-bold text-plum sm:text-lg" data-id="element-39" data-mp="1xk92dm6p3ka9">
            💰 Total bonus value: <span className="text-plum/50 line-through" data-id="element-40" data-mp="1tjgrypm379ce">$120</span>{' '}
            <span className="text-[15px] text-grape-deep" data-id="element-41" data-mp="1olf65wxa0vx8">
              FREE TODAY WITH THE 5 IN 1 COMBO
            </span>
          </p>
        </div>
      </div>
    </section>;
}